import React from 'react';

import { Button, Flex } from '@rover/kibble/core';
import { getTrainerSearchPageUrl } from '@rover/react-lib/src/pages/training/utils/params';
import { ServiceTypeSlugEnum } from '@rover/rsdk/src/apiClient/latest/model/serviceTypeSlugEnum';
import { TrainingSearchQuery } from '@rover/rsdk/src/apiClient/latest/model/trainingSearchQuery';
import { TrainingSearchResponse } from '@rover/rsdk/src/apiClient/latest/model/trainingSearchResponse';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';
import { storeCrossPageAnalyticsEvent } from '@rover/utilities/fireCrossPageEvent';

import TrainingSearchResultsCarousel from '../../../../components/TrainingSearchResultsCarousel';
import {
  CarouselPaginateAction,
  ClickSitterCard,
  SearchResultLayoutType,
  SearchResultsCtaClick,
  SitterCardType,
  ViewSitterCard,
} from '../../../../utilities/analyticsEvents';
import { PageSectionId, useSectionRef } from '../../../hooks/useSectionRef';
import { SeoLocationPageProps } from '../../../types';

type Props = {
  searchResponse: TrainingSearchResponse;
  heading: string;
  searchFilters?: Partial<TrainingSearchQuery>;
  countryConfig: SeoLocationPageProps['countryConfig'];
};

const TrainingSeoLocationResultsCarousel: React.FC<Props> = ({
  searchResponse,
  heading,
  searchFilters = {},
  countryConfig,
}: Props) => {
  const serviceTypeSlug = ServiceTypeSlugEnum['dog-training'];
  const sectionRef = useSectionRef(PageSectionId.CarouselSearchResults, { threshold: 0.6 });

  return (
    <Flex htmlRef={sectionRef} gap="6x" flexDirection="column" alignItems="center">
      <TrainingSearchResultsCarousel
        searchResults={searchResponse.results}
        heading={heading}
        shouldUsePriceTransparency={searchResponse.shouldUsePriceTransparency}
        onPaginate={({ pageStart, pageEnd, scrollSource }) => {
          emitAnalyticsEvent(
            new CarouselPaginateAction({
              serviceTypeSlug,
              pageStart,
              pageEnd,
              scrollSource,
            })
          );
        }}
        onSearchResultCardClick={() => {
          storeCrossPageAnalyticsEvent(
            new ClickSitterCard({
              serviceTypeSlug,
              cardType: SitterCardType.CAROUSEL,
            })
          );
        }}
        onSearchResultCardViewed={(personOpk) => {
          emitAnalyticsEvent(
            new ViewSitterCard({
              serviceTypeSlug,
              cardType: SitterCardType.CAROUSEL,
              sitterResultPersonOpk: personOpk,
            })
          );
        }}
        rootCarouselRef={sectionRef}
        countryConfig={countryConfig}
      />
      <Button
        width="100%"
        maxWidth={['335px']}
        href={getTrainerSearchPageUrl(searchFilters)}
        onPress={() => {
          storeCrossPageAnalyticsEvent(
            new SearchResultsCtaClick({
              serviceTypeSlug,
              layoutType: SearchResultLayoutType.CAROUSEL,
            })
          );
        }}
      >
        {/* DEV-104195: Translate */}
        View more trainers
      </Button>
    </Flex>
  );
};
export default TrainingSeoLocationResultsCarousel;
